// src/components/auth/ProtectedRoute.jsx
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { currentUser, loading } = useContext(AuthContext);

    // Show loading state while checking authentication
    if (loading) {
        return <div className="loading">Loading...</div>;
    }

    // Redirect to login if not authenticated
    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    // Render children if authenticated
    return children;
};

export default ProtectedRoute;